import styled, { css } from 'styled-components';
import { HeadingStyle } from 'components/heading';
import { device, spacing } from 'commons';

export const HeaderWrapper = styled.div<{
  $status: string;
  $returnStatus?: string;
}>`
  color: ${({ theme, $status, $returnStatus }) => {
    if ($returnStatus) {
      const statusColor =
        theme.returnStatus[$returnStatus] || theme.returnStatus['default'];

      return statusColor.primary;
    } else {
      const statusColor =
        theme.consignmentStatus[$status] || theme.consignmentStatus['default'];

      return statusColor.primary;
    }
  }};
`;

export const StatusBar = styled.div`
  height: 10px;
  background-color: currentColor;
`;

export const Main = styled.div`
  font-size: 12px;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.neutral_100};
  padding: 0 ${spacing.detailsSidePadding} 0 ${spacing.detailsSidePadding};
  box-shadow: 0 10px 10px ${({ theme }) => theme.neutral_200};

  @media (max-width: ${device.mobile}px) {
    padding: 0 32px;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  gap: 8px;
  padding: 20px 0;

  @media (max-width: ${device.tablet}px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const Retractable = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-flow: row wrap;
  gap: 24px;
  padding-bottom: 20px;
  color: ${({ theme }) => theme.neutral_500};

  @media (max-width: ${device.tablet}px) {
    flex-direction: column;
  }
`;

export const LargeWrapper = styled.div`
  display: flex;
  flex: 3;
  justify-content: space-between;
`;

export const CodeWrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  gap: 6px;
  padding-right: 10px;

  ${HeadingStyle} {
    white-space: nowrap;
    color: ${({ theme }) => theme.neutral_500};
  }
`;

export const Container = styled.div`
  display: flex;
  gap: 25px;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const FirstContainer = styled(Column)`
  padding-right: 10px;
`;

export const StatusWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  p {
    color: ${({ theme }) => theme.neutral_500};
  }
`;

export const Status = styled.div`
  padding: 5px 15px;
  font-size: 12px;
  font-weight: 400;
  border-radius: 20px;
  border: 1px solid currentColor;
  color: currentColor;
  white-space: nowrap;
`;

export const Button = styled.button<{ $showMore: boolean }>`
  background-color: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 22px;
    height: 22px;
  }

  ${({ $showMore }) =>
    $showMore &&
    css`
      svg {
        transform: rotate(180deg);
      }
    `}
`;

export const BoldText = styled.strong`
  display: inline;
  font-weight: bold;
  font-size: inherit;
`;

export const TextContainer = styled.div<{ $column?: boolean }>`
  display: flex;
  gap: 5px;

  ${({ $column }) =>
    $column &&
    css`
      flex-direction: column;
      gap: unset;
    `}
`;
